import { parseISO } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export const stringToDate = (string: string) =>
    fromZonedTime(
        parseISO(string),
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
